import {ComponentPropsWithoutRef, ReactNode} from "react";

import {Button} from "@/components/button/Button";
import {BaseButtonProps} from "@/components/button/Button.types";
import {Tooltip} from "@/components/toolTip/Tooltip";

type TableCrownButtonProps = Omit<BaseButtonProps, "variant" | "typography"> &
  Omit<ComponentPropsWithoutRef<"button">, keyof BaseButtonProps> & {
    tooltip?: ReactNode;
  };

export const TableCrownButton = ({tooltip, ...props}: TableCrownButtonProps) => {
  const button = <Button variant="quickActions" typography="link" {...props} />;

  if (tooltip) {
    return <Tooltip tooltipContent={tooltip}>{button}</Tooltip>;
  }

  return button;
};
